import { FC } from "preact/compat";
import { RawHtml } from "~/components";
import { useTooltips } from "~/hooks";
import { build } from "./build";
import { DiscoveryDetailsRendererProps } from "./interfaces";

const REGEXP = /\/me\/\w+\/\w+\/(.*)/;

// @DEP @LINK depends on routing structure
const getCurrentPath = () => {
    const match = window.location.pathname.match(REGEXP);

    if (!match) {
        return "";
    }

    let [, path] = match;
    const params = new URLSearchParams(window.location.search);

    // only 'calendar' param is used for now

    if (params.has("calendar")) {
        path += `?calendar=${params.get("calendar")}`;
    }

    return path;
};

const DiscoveryDetailsRenderer: FC<DiscoveryDetailsRendererProps> = ({
    details,
    ctx,
}) => {
    useTooltips();

    const content = build(details, { ...ctx, $path: getCurrentPath() });

    return <RawHtml className="discovery-root" html={content} />;
};

export default DiscoveryDetailsRenderer;
